import React, { useEffect, useState } from "react"
import {
  Badge,
  Card,
  CardBody,
  CardFooter,
  CardSubtitle,
  CardTitle,
  Col,
  Row,
  Table,
} from "reactstrap"
import { MetaTags } from "react-meta-tags"
import { useDispatch, useSelector } from "react-redux"
import moment from "moment"
import { filter, map } from "lodash"
import { Markup } from "interweave"

import Breadcrumb from "../Common/Breadcrumb"
import noImg from "assets/images/product.jpeg"

//images
import logo from "../../assets/images/logo/Indtech.png"
import { getQuotationDetail, reviseQuotation } from "store/actions"
import { useHistory, useParams } from "react-router-dom"
import OrderDetails from "pages/Orders/SingleView"

const PDFGenerator = () => {
  const params = useParams()
  const dispatch = useDispatch()
  const history = useHistory()

  //redux state
  const { quotationDetails } = useSelector(state => ({
    quotationCurd: state.Orders.quotationCurd,
    AllQProducts: state.Orders.AllQProducts,
    QuotationItems: state.Orders.quotation.quotationitem,
    quotationDetails: state.Orders.quotationDetails,
  }))

  // useEffect(() => {
  //   setTimeout(() => {
  //     window.print()
  //   }, 2000)
  // }, [])

  useEffect(() => {
    dispatch(getQuotationDetail(params?.id))
  }, [])

  const letterHead = quotationDetails?.letter_head
  const bank_details = quotationDetails?.bank_details
  const trems_and_conditions = quotationDetails?.terms
  const warrenty = quotationDetails?.warrenty

  const [printMode, setPrintMode] = useState("compact")

  const handlePrint = mode => {
    setPrintMode(mode)
    setTimeout(() => {
      window.print()
    }, 150)
  }

  const download = () => {
    window.print()
  }

  const difference = quotationDetails?.mrp_total - quotationDetails?.total

  // const discountedAmount =
  //   quotationDetails?.mrp_total - quotationDetails?.discount

  const calculateGST = (price, quantity) => {
    const gstRate = quotationDetails?.tax_percentage || 18
    const calculatedGst = (price * quantity * gstRate) / 100
    return calculatedGst.toFixed(2)
  }


  const calculateTotalAmountWithGST = (taxPercentage, price, quantity) => {
    const totalPrice = price * quantity

    const calculatedGst = (totalPrice * taxPercentage) / 100
    const finalPrice = totalPrice + calculatedGst
    return finalPrice?.toFixed(2)
  }

  return (
    <>
      <MetaTags>
        <title> &nbsp; </title>
      </MetaTags>
      <div className="page-content">
        <Breadcrumb title="Quotation" breadcrumbItem="Quotation PDF" />
        <Card className={`p-4 d-flex ${printMode === "compact" ? "compact-print-mode" : "standard-print-mode"}`}>

          <div className="d-flex align-items-center mb-3 display-none" style={{ marginLeft: "auto", gap: "10px" }}>
            <button
              type="button"
              className={`btn btn-sm ${printMode === "compact" ? "btn-primary" : "btn-outline-primary"} d-flex align-items-center`}
              onClick={() => handlePrint("compact")}
              title="Prints continuously with reduced spacing to avoid large empty gaps"
            >
              <i className="mdi mdi-printer-pos font-size-16 me-1"></i>
              Print (No Blank Space)
            </button>

            <button
              type="button"
              className={`btn btn-sm ${printMode === "standard" ? "btn-secondary" : "btn-outline-secondary"} d-flex align-items-center`}
              onClick={() => handlePrint("standard")}
              title="Standard print mode with default row spacing"
            >
              <i className="mdi mdi-printer font-size-16 me-1"></i>
              Print (Auto Blank Space)
            </button>

            {/* Revise Quotation Button */}
            <button
              type="button"
              className="btn btn-sm btn-warning d-flex align-items-center"
              onClick={() => dispatch(reviseQuotation(params?.id, history))}
            >
              <i className="mdi mdi-pencil-box-outline font-size-16 me-1"></i>
              Revise
            </button>
          </div>
          <CardBody>
            <CardTitle>
              <img
                src={logo}
                alt="indetch-logo"
                height={80}
                className=" mx-auto"
              />
            </CardTitle>

            {/* <CardTitle
              style={{ textAlign: "center" }}
              className="mb-0 mt-4 font-size-18"
            >
              Quotation
            </CardTitle> */}
            <CardSubtitle className="mb-0 mt-0">
              <Row style={{ alignItems: "end" }}>
                <div className="d-flex align-item-center justify-content-between">
                  <div>
                    <div className="mt-2">
                      <h5>To,</h5>
                      <h6 style={{ paddingLeft: "1rem" }}>
                        {quotationDetails?.client_name}
                      </h6>
                      <h6 style={{ paddingLeft: "1rem", paddingRight: "1rem" }}>
                        {quotationDetails?.client_address}
                      </h6>
                    </div>
                  </div>
                  <div className="">
                    <h6>
                      Date :
                      {moment(quotationDetails?.date_added).format(
                        "DD/MM/YYYY"
                      )}
                    </h6>
                    <div className="d-flex align-items-center">
                      <h6>
                        <span style={{ fontWeight: 600, textTransform: "capitalize" }}>
                          {quotationDetails?.document_type} No :{" "}
                          {quotationDetails?.display_quotation_no || quotationDetails?.auto_id}
                        </span>
                        {quotationDetails?.revision_number > 1 && (
                          <span
                            style={{
                              marginLeft: "8px",
                              background: "#f0ad4e",
                              color: "#fff",
                              padding: "2px 8px",
                              borderRadius: "4px",
                              fontSize: "12px",
                              fontWeight: 700,
                            }}
                          >
                            Rev. {quotationDetails?.revision_number}
                          </span>
                        )}
                      </h6>
                    </div>
                    <small>Point Of Contact</small>
                    <div
                      style={{
                        border: "0.1px ridge  rgb(209, 202, 202)",
                        padding: 15,
                        borderRadius: 5,
                      }}
                    >
                      <span className="font-size-13">
                        Name &nbsp;: &nbsp;
                        <span className="text-black">
                          &nbsp; {quotationDetails?.contact_person}
                        </span>{" "}
                      </span>
                      <br />
                      <span className="font-size-13">
                        {" "}
                        Phone &nbsp;: &nbsp;
                        <span className="text-black">
                          {quotationDetails?.contact_person_phone}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </Row>
            </CardSubtitle>

            {letterHead && letterHead !== '<p></p>' && (
              <CardSubtitle className="">
                <Markup content={letterHead} />
              </CardSubtitle>
            )}

            <div className="table-responsive">
              <Table className="table mb-0 table-bordered pdf-bordered tdf">
                <tbody>
                  <tr>
                    <th style={{ maxWidth: 45, fontSize: 12 }} className="">
                      SL.NO
                    </th>
                    <th style={{ fontSize: 12 }}>PRODUCT </th>

                    <th style={{ fontSize: 12 }}>IMAGE</th>
                    <th style={{ maxWidth: 120, fontSize: 12 }}>PRICE</th>
                    <th style={{ maxWidth: 100, fontSize: 12 }}>GST</th>
                    {quotationDetails.document_type == "order" && (
                      <th style={{ maxWidth: 50, fontSize: 12 }}>QTY</th>
                    )}
                    <th style={{ fontSize: 12, maxWidth: "auto" }} className="">
                      AMOUNT
                    </th>
                  </tr>

                  {quotationDetails?.quotationitem && (
                    <>
                      {map(
                        quotationDetails?.quotationitem,
                        (quotation, key) => (
                          <tr key={key}>
                            <td>{key + 1}</td>
                            <td>
                              <h3 className="text-info font-size-16 mb-2">
                                {quotation?.product_code ? `${quotation?.product_code} - ` : ""}
                                {quotation?.product_name || quotation?.item_name}
                              </h3>

                              {quotation?.rich_text_detail && (
                                <div className="mb-2 font-size-13 text-muted">
                                  <Markup content={quotation.rich_text_detail} />
                                </div>
                              )}

                              <ul>
                                {map(
                                  quotation?.product_detail?.filter(
                                    item => item.is_description == true
                                  ),
                                  (des, deskey) => (
                                    <li key={deskey} className="pb-1">
                                      {/* <div className="d-flex ">
                                        <h6
                                          className=""
                                          style={{ fontSize: "14px" }}
                                        >
                                          {des.title}
                                        </h6>
                                        <p>{des.detail}</p>{" "}
                                      </div> */}
                                      {/* <h6
                                          className=""
                                          style={{ fontSize: "14px" }}
                                        > */}
                                      <span className="h6">
                                        {des.title} : &nbsp;
                                      </span>
                                      <span className="">{des.detail}</span>
                                      {/* Assuming 'detail' is text, so using <p> instead of another <h6> */}
                                    </li>
                                  )
                                )}
                              </ul>

                              <div className="mt-4">
                                {map(
                                  quotation?.product_detail?.filter(
                                    item => item.is_description == false
                                  ),
                                  (des2, deskey2) => (
                                    <div key={deskey2} className="pb-1">
                                      <small
                                        className="text-black-head"
                                        style={{ fontWeight: 500 }}
                                      >
                                        {des2.title}
                                      </small>
                                      <div>
                                        {" "}
                                        <small>{des2.detail}</small>
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>
                            </td>

                            <td className="p-0">
                              <img
                                src={
                                  quotation?.image_url
                                    ? quotation?.image_url
                                    : ""
                                }
                                alt=""
                                id="expandedImg1"
                                className="mb-5 p-0"
                                style={{
                                  maxWidth: "300px",
                                  height: 140,
                                  minWidth: 140,
                                  objectFit: "contain",
                                }}
                              />
                            </td>


                            <td>
                              {/* {quotationDetails?.discount > 0 ? ( */}
                              <>
                                {/* <small className="text-black font-size-10 text-decoration-line-through">
                                    {parseFloat(quotation?.mrp)}
                                  </small><br /> */}
                                <small className="text-black font-size-10">
                                  {parseFloat(quotation?.price)}
                                </small>
                              </>
                              {/* ) : (
                                <small className="text-black font-size-10">
                                  {parseFloat(quotation?.mrp)}
                                </small>
                              )} */}
                            </td>

                            <td>
                              <small className="text-black font-size-10">
                                {/* {`${quotation?.tax_amount} (${quotation?.tax_percentage}%)`} */}
                                {`${quotation?.tax_amount} (${(() => {
                                  const tp = parseFloat(quotation?.tax_percentage)
                                  return Number.isFinite(tp)
                                    ? tp % 1 === 0
                                      ? tp.toFixed(0)
                                      : tp
                                    : quotation?.tax_percentage
                                })()}%)`}
                              </small>
                            </td>
                            {quotationDetails.document_type == "order" && (
                              <td>
                                <small className="text-black font-size-10">
                                  {/* <i className="bx bx-rupee" /> */}
                                  {quotation?.qty || 0}
                                </small>
                              </td>)}
                            <td>
                              <small
                                className="text-black font-size-10"
                                style={{ fontWeight: 600 }}
                              >
                                {/* <i className="bx bx-rupee" /> */}
                                {/* {quotation?.qty * quotation?.mrp || 0} */}

                                {calculateTotalAmountWithGST(
                                  quotation?.tax_percentage,
                                  quotation?.price,
                                  quotationDetails.document_type == "order" ? quotation?.qty : 1
                                )}
                              </small>
                            </td>
                          </tr>
                        )
                      )}
                    </>
                  )}
                </tbody>
              </Table>
            </div>

            {quotationDetails?.document_type == "order" && (
              <>

                <>
                  {/* <div className="d-flex align-items-center justify-content-end pt-4">
                    <div className="" style={{ width: 300 }}>
                      <div className="row">
                        <div className="col-6">
                          <small className="text-black font-size-12">
                            Total Amount &nbsp;:&nbsp;
                          </small>
                        </div>
                        <div className="col-6">
                          <small className="text-black font-size-12">
                            {parseFloat(quotationDetails?.total).toFixed(2)}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div> */}

                  {/* <div className="d-flex align-items-center justify-content-end py-1">
                    <div className="" style={{ width: 300 }}>
                      <div className="row">
                        <div className="col-6">
                          <small className="text-black font-size-12">
                            Total Discount &nbsp;:
                          </small>
                          &nbsp;
                        </div>
                        <div className="col-6">
                          {quotationDetails?.discount && (
                            <small className="text-black font-size-12">
                              {parseFloat(quotationDetails?.discount)}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>
                  </div> */}
                  <div className="d-flex align-items-center justify-content-end py-1">
                    <div className="" style={{ width: 300 }}>
                      <div className="row">
                        <div className="col-6">
                          <small className="text-black font-size-12">
                            Total Tax &nbsp;:
                          </small>
                          &nbsp;
                        </div>
                        <div className="col-6">
                          {quotationDetails?.tax_amount && (
                            <small className="text-black font-size-12">
                              {parseFloat(quotationDetails?.tax_amount).toFixed(2)}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>

                <div className="d-flex align-items-center justify-content-end py-1">
                  <div className="" style={{ width: 300 }}>
                    <div className="row">
                      <div className="col-6">
                        <small
                          className="text-black font-size-12"
                          style={{ fontWeight: 500 }}>
                          Net Amount&nbsp; : &nbsp;
                        </small>
                      </div>
                      <div className="col-6 ">
                        <small
                          className="text-black font-size-14"
                          style={{ fontWeight: 500 }}
                        >
                          {quotationDetails?.payable_amount}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}


            <div className="p-2 pt-1 pb-1 mt-1">
              {quotationDetails?.letter_middle && (
                <p className="mt-1 pt-1 mb-1 pb-1">
                  {quotationDetails?.letter_middle}
                </p>
              )}

              {trems_and_conditions && trems_and_conditions !== '<p></p>' && (
                <>
                  <h5 className="mb-2">Terms and Conditions :</h5>
                  <Markup content={trems_and_conditions} />
                </>
              )}
            </div>
            {warrenty && warrenty !== '<p></p>' && (
              <>
                <h5 className="mb-2">Warranty clause : </h5>
                <Markup content={warrenty} />
              </>
            )}
            {bank_details && bank_details !== '<p></p>' && (
              <>
                <h5 className="mb-2">Account Details : </h5>
                <Markup content={bank_details} />
              </>
            )}

            <div style={{ width: "fit-content", marginLeft: "" }}>
              {/* <h5 className="mt-5 pt-3">Thanking you</h5> */}
              <h5 className="pb-5 mb-5">Authorized Signatory</h5>

            </div>
            <div style={{ height: "180px" }}></div>
          </CardBody>
          <div
            style={{
              position: "absolute",
              bottom: 0,
              width: "100%",
            }}
          >
            <Row className="">
              <Col
                className="col-4 p-1"
              >
                <div className="d-flex">
                  {/* <i
                    style={{
                      fontSize: "22px",
                      color: "#1495d3",
                      padding: "0 1rem",
                    }}
                    className="dripicons-location"
                  ></i> */}
                  <div>
                    <h5 className="mb-2" style={{ fontSize: 14 }}>
                      <i
                        style={{
                          fontSize: "15px",
                          color: "#1495d3",
                          // padding: "0 0rem",
                          paddingRight: "0.3rem"
                        }}
                        className="dripicons-location"
                      ></i>
                      Corporate Office</h5>
                    <p>
                      Plot No: B5, Industrial development plot, Paloor kotta,
                      Palachode Post,
                      Angadippuram via,
                      Malappuram, <b>Kerala</b> 679338
                    </p>
                  </div>
                </div>
              </Col>

              <Col
                className="col-4 p-1"
              >
                <div className="d-flex">
                  {/* <i
                    style={{
                      fontSize: "22px",
                      color: "#1495d3",
                      padding: "0 1rem",
                    }}
                    className="dripicons-location"
                  ></i> */}
                  <div>
                    <h5 className="mb-2" style={{ fontSize: 14 }}><i
                      style={{
                        fontSize: "15px",
                        color: "#1495d3",
                        // padding: "0 0rem",
                        paddingRight: "0.3rem"
                      }}
                      className="dripicons-location"
                    ></i>Regional Office</h5>

                    <p>
                      House of Iniyan nila,
                      Kaduvettipalayam,
                      Karumathampatti,
                      Coimbatore, <br /><b>Tamil Nadu</b> 641659
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                className="col-4 p-1"
              >
                <div className="d-flex">
                  {/* <i
                    style={{
                      fontSize: "22px",
                      color: "#1495d3",
                      padding: "0 1rem",
                    }}
                    className="dripicons-location"
                  ></i> */}
                  <div>
                    <h5 className="mb-2" style={{ fontSize: 14 }}><i
                      style={{
                        fontSize: "15px",
                        color: "#1495d3",
                        // padding: "0 0rem",
                        paddingRight: "0.3rem"
                      }}
                      className="dripicons-location"
                    ></i>Regional Office</h5>
                    <p>
                      Anthony Nilayam, 2nd Cross Rd,<br />
                      Lakeview Residency,
                      Banjara Layout,
                      Bengaluru,<br /> <b>Karnataka</b> 560043
                    </p>
                  </div>
                </div>
              </Col>

              <Col className="col-12">
                <div className="mt-2" style={{ textAlign: 'center' }}>
                  <h6>KERALA | TAMIL NADU | KARNATAKA </h6>
                  <p>www.indtechhc.com | info@indtechhc.com | +91 7594 822 822</p>
                </div>
              </Col>
            </Row>
          </div>
        </Card>
      </div>
    </>
  )
}

export default PDFGenerator
